import { FocusEvent, MouseEvent } from 'react';

const FOCUS_WINDOW_MS = 500;
const focusedAt = new WeakMap<HTMLInputElement, number>();

export const selectAllOnFocus = {
  onFocus: (event: FocusEvent<HTMLInputElement>) => {
    const input = event.target;
    if (!input) {
      return;
    }
    focusedAt.set(input, Date.now());
    try {
      input.select();
    } catch (e) {
      focusedAt.delete(input);
    }
  },
  onMouseUp: (event: MouseEvent<HTMLInputElement>) => {
    const input = event.currentTarget;
    const at = focusedAt.get(input);
    focusedAt.delete(input);
    if (at !== undefined && Date.now() - at < FOCUS_WINDOW_MS) {
      event.preventDefault();
    }
  },
};

export default selectAllOnFocus;
